import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Dropdown } from "react-bootstrap";
import styled from "styled-components";
export const Container = styled.div`
    width: 100%;
    position: relative;
`
export const TableContainer = styled.table`
    width: 100%;
    tr th:first-child{
        border-top-left-radius: 10px;
    }
    tr th:last-child{
        border-top-right-radius: 10px;
    }
    
    
    tr:nth-child(even) td {
        background-color: rgba(0,0,0,0.2);
    }

    tr:nth-child(odd) td {
        background-color: rgba(0,0,0,0.1);
    }
    tr.tr-link{
        cursor: pointer;
        transition: all ease-in-out .6s;
        &:hover{
            td{
                background: #1a1a1a;
                transition: all ease-in-out .6s;
            }
        }
    }
    @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
        display: block;

        & thead,
        tbody,
        th,
        td,
        tr {
            display: block;
        }

        & thead tr {
            display: none;
        }

        & tr {
            margin-bottom: 15px;
            background-color: rgba(0,0,0,0.1);
            border-radius: 15px;
            padding: .5em;
        }

        & td {
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 8px 10px;
            border: none;
            background: none;
            border-bottom: 1px solid rgba(255, 255, 255, .1);
            &:last-child{
                border-bottom:0;
            }
            .mobile{
                display: block;
            }
        }
        & td button{
            width: 100%;
            margin-top: .5em;
        }
    }
`
export const HeaderWrapper = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    gap: .5em;
`
export const Header = styled.th`
    background: rgba(255,255,255,0.05);
    padding: .8em .5em;
    text-align: center;
    font-weight: bold;
`
export const CenterColumn = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    gap: .5em;
`
export const Column = styled.td`
    padding: .8em .5em;
    text-align: center;
    background: #393939;
    .mobile{
        display: none;
    }
    
    .row-tools{
        width: 12px;
        height: 12px;
        border: 1px solid #333;
        padding: 4px;
        border-radius: 100%;
        transition: all ease-in-out .3s;
        cursor: pointer;
        &:hover{
            color: var(--primary-color);
            border-color: var(--primary-color);
            transition: all ease-in-out .3s;
        }
    }
    
`
export const PaginationInfo = styled.div`
    display: flex;
    justify-content: start;
    align-items: center;
    @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
        justify-content: center;
    }
`
export const PaginationContainer = styled.div`
    display: grid;
    padding: 1em;
    grid-template-columns: 1fr 3fr;
    background: rgba(0, 0, 0, .1);
    border-radius: 10px;
    margin-top: 0em;
    border-top-left-radius: 0px;
    border-top-right-radius: 0px;
    @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
        display: block;
        border-radius: 10px;
    }
    & ul{
        list-style: none;
        padding:0;
        margin:0;
        gap: .5em;
        display: flex;
        justify-content: end;
        align-items: center;
        @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
            justify-content: center;
            margin-top: 1em;
        }
        & li{
            width: 2.2em;
            height: 2.2em;
            background: rgba(0,0,0,0.2);
            display: flex;
            justify-content: center;
            border-radius: 10px;
            border: none;
            align-items: center;
            cursor: pointer;
            transition: all ease-in-out .3s;
            &.active, &:hover{
                background: var(--primary-color);
                transition: all ease-in-out .3s;
            }
            &.active{
                cursor: default;
            }
            &.disabled{
                cursor: default;
                color: rgba(255,255,255,0.2);
                background: rgba(255,255,255,0.05);
                &:hover{
                    color: rgba(255,255,255,0.2);
                    background: rgba(255,255,255,0.05);
                }
            }
            &.dots{
                cursor: default;
                background: transparent;
                &:hover{
                    background: transparent;
                }
            }
            & svg{
                width: 7px;
            }
        }
    }
`
export const Status = styled.span`
    padding: .2em .5em;
    font-size: .8em;
    color: #fff;
    border-radius: 10px;
    min-width: 90px;
    ${(props) => props.color && props.color === "success" && `background-color: #08a95e;`}
    ${(props) => props.color && props.color === "danger" && `background-color: #dc3545;`}
    ${(props) => props.color && props.color === "warning" && `background-color: #ffb549; color: #333;`}
`
export const LoadingContainer = styled.div`
    position: absolute;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    border-radius: 10px;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 999;
    top: 0;
`
export const LoadingWrapper = styled.div`

`
export const Loading = styled.div`
    border: 3px solid rgba(255, 255, 255, .5);
    width: 24px;
    height: 24px;
    -webkit-animation: rotate 1s infinite linear;
    -moz-animation: rotate 1s infinite linear;
    -ms-animation: rotate 1s infinite linear;
    -o-animation: rotate 1s infinite linear;
    animation: rotate 1s infinite linear;
    
    -webkit-border-radius: 50%;
    -moz-border-radius: 50%;
    -ms-border-radius: 50%;
    -o-border-radius: 50%;
    border-radius: 50%;

    & span{
        position: absolute;
        border: 3px solid transparent;
        width: 24px;
        height: 24px;
        border-top: 3px solid rgba(255, 255, 255, .75);
        top: -3px;
        left: -3px;
        -webkit-border-radius: 50%;
        -moz-border-radius: 50%;
        -ms-border-radius: 50%;
        -o-border-radius: 50%;
        border-radius: 50%;
    }
`
export const SuccessStatus = styled(FontAwesomeIcon)`
    color:rgb(19, 169, 39);
    font-size: 26px;
`
export const ErrorStatus = styled(FontAwesomeIcon)`
    color:rgb(169, 19, 19);
    font-size: 26px;
`
export const TableActionButton = styled.button`
    padding: .5em 1em;
    font-weight: normal;
    font-size: 1em;
    background: rgba(255, 255, 255, .1);
    border-radius: 10px;
    border: none;
    color: #fff;
    transition: all ease-in-out .2s;
    &:hover{
        background: var(--primary-color);
        transition: all ease-in-out .2s;
    }
    & svg{
        font-size: 20px;
    }
    ${({ $disabled }) => $disabled?`
        cursor: default !important;
        background: rgba(255,255,255, .04);
        &:hover{
            background: rgba(255,255,255, .04);
        }
    `:``}
`
export const DetailsInfoCard = styled.div`
    margin-bottom: 1em;
    padding: 1em;
    background: rgba(0, 0, 0, 0.1);
    border-radius: 20px;
    font-size:1.2em;
`
export const DetailsInfoRow = styled.div`
    display: grid;
    grid-template-columns: 1fr 2fr;
    margin-bottom: .6em;
    a {
        color: var(--primary-color);
    }
    @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
        display: block;
        b{
            display: block;
        }
    }
`
export const DataActionContainer = styled.div`
    position: relative;
    & svg{
        cursor: pointer;
        transition: all ease-in-out .3s;
        &:hover, &.active{
            transition: all ease-in-out .3s;
            color: var(--primary-color);
        }
    }
    
`

export const PopupContainer = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: var(--bs-modal-overlay-bg);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1000;
    direction: ltr;
    &.fa-IR{
        direction: rtl;
    }
    @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
        background-color: #000;
    }
`
export const PopupModal = styled.div`
    padding: .5em;
    position: relative;
    min-height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
    flex: 1;
    max-width: 500px;
    &.confirm{
        margin-top: 2em;
        border-radius: 15px;
        box-shadow: 0 0 .5em .2rem var(--bs-modal-shadow);
        min-height: fit-content;
    }
    @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
        min-height: calc(100vh - (48px + 1em));
    }
    @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        flex: 1;
        border-radius: 0;
    }
    
`
export const PopupHeader = styled.h3`
    display: flex;
    justify-content: start;
    gap: .5em;
    font-size: 1.2em;
    font-weight: bold;
    color: var(--primary-color);
    line-height: 26px;
`
export const PopupBody = styled.div`
    padding: 1em;
    width: 100%;
    
`
export const ConfirmModalWrapper = styled.div`
    background: #fff;
    border-radius: 20px;
    color: #000;
    padding: .5em;
    width: 100%;
`

export const PopupFooter = styled.div`
    padding: 0.5em 0 1em 0;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: .5em;
    & button{
        width: 100%;
    }
`
export const PopupForm = styled.div`
    margin-top: 1em;
`
export const DataTableFilterContainer = styled.div`
    padding: .8em 0;
    border-radius: 10px;
    display: flex;
    gap: .5em;
    align-items: center;
    flex-wrap: wrap;
    & .form-control{
        padding-left: 0;
        &::placeholder {
            color: rgba(255,255,255,.4);  
            opacity: 1;   
        }
    }
    & .input-group-text, & .form-control{
        background: transparent;
        box-shadow: none;
        border: none;
    }
    & .input-group{
        background: rgba(0, 0, 0, 0.2);
        border-radius: 10px;
        padding: .5em;
        gap: .3em;
    }
    & .btn-search, & .btn-refresh{
        background: var(--primary-color);
        border-radius: 10px !important;
        padding: .7em 1.5em;
        cursor: pointer;
        transition: all ease-in-out .3s;
        &:hover{
            transition: all ease-in-out .3s;
            color: var(--primary-color);
            background: rgba(255,255,255,.8);
        }
        &.disabled{
            cursor: initial;
            background: rgba(255, 255, 255, .1);
            color: rgba(255, 255, 255, .3);
        }
    }
    & .btn-refresh{
        padding: .7em .8em;
        
    }
`
export const DataTableFilter = styled.div`
    position: relative;
    background: rgba(0, 0, 0, 0.3);
    border-radius: 10px;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    transition: all ease-in-out .3s;
    &:hover{
        transition: all ease-in-out .3s;
        background: rgba(255, 255, 255, 0.2);
    }
    .dropdown-menu{
        --bs-dropdown-min-width: 15rem;
        --bs-dropdown-bg: rgb(23 26 29);
        --bs-dropdown-border-color: rgb(23 26 29 / 20%);
        --bs-dropdown-padding-y: 0;
        --bs-dropdown-border-radius: 15px;
        --bs-dropdown-item-padding-x: 1rem;
        --bs-dropdown-item-padding-y: 0.5rem;
        --bs-dropdown-link-hover-color: #fff;
        --bs-dropdown-link-hover-bg: var(--primary-color);
        --bs-dropdown-link-active-color: #fff;
        --bs-dropdown-link-active-bg: var(--primary-color);
        .dropdown-item{
            border-radius: 10px;
            margin: 0.3em 0;
            &:hover{
                text-decoration: none;
                background: var(--bs-dropdown-link-hover-bg);
            }
        }
    }
    
`
export const DataTableFilterData = styled.div`
    display: flex;
    justify-content: start;
    align-items: center;
    gap: .5em;
    padding: .5em 0 .5em 1em;
    ${({ $clearAll, $forceFilter }) => `
        ${$clearAll?`padding: .5em 1em .5em 1em;`:``}
        ${$forceFilter?`padding: .5em 1em .5em 1em;`:``}
    `}}
    
`
export const DataTableFilterButton = styled.div`
    display: flex;
    justify-content: start;
    align-items: center;
    gap: .5em;
    padding: .5em 1em .5em 1em;
    &:after{
        display: none;
    }
`
export const DataTableFilterDelete = styled.div`
    cursor: pointer;
    color: var(--primary-color);
    width: 35px;
    height: 35px;
    display: flex;
    justify-content: center;
    align-items: center;
    transition: all ease-in-out .3s;
    &:hover{
        transition: all ease-in-out .3s;
        color: var(--text-color);
    }
`
export const NotFoundContainer = styled.div`
    width: 100%;
    height: fit-content;
    display: flex;
    justify-content: center;
    align-items: center;
    padding-top: 2em;
    
`
export const NotFoundWrapper = styled.div`
    text-align: center;
    h3{
        font-size: 1.6em;
        font-weight: bold;
        margin-bottom: .3em;
    }
    p{
        font-size: 1em;
        color: rgba(255,255,255,.4);
    }
`
export const NotFoundIcon = styled.div`
    width: 6em;
    margin: 0 auto;
    height: 6em;
    display: flex;
    justify-content: center;
    align-items: center;
    background: rgba(255, 255, 255, 0.1);
    border-radius: 50%;
    margin-bottom: 1em;
    svg{
        font-size: 32px;
    }
`